import React from "react";
import Chart from "../../Chart";
import ExampleFunnelChart from "../../../../components/Chart/ExampleFunnelChart";

class FunnelChartExampleApplet extends Chart {

    render() {
        return <ExampleFunnelChart applet={this}
                          attributes={this.state.Attributes}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "FunnelChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        Series: [
            {
                type: "funnel",
                data: [],
                id: "funnelId",
            }
        ]
    }
}

export default FunnelChartExampleApplet;
